import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

import { getOption, useSponsorshipStatusOptions } from '../../../utils'
import { SponsorshipStatus } from '../../../types'
import { StatusTag, StatusTagProps } from '../../root/components/StatusTag'

export default function SponsorshipStatusTag({
  status,
  absolute,
  position = 'top',
  size = 'medium',
}: {
  status?: SponsorshipStatus | null
} & Partial<StatusTagProps>) {
  const { t } = useTranslation('events')
  const statusOptions = useSponsorshipStatusOptions(t)

  const option = useMemo(() => getOption(statusOptions, undefined, status), [statusOptions, status])

  return option?.label ? (
    <StatusTag size={size} absolute={absolute} color={option.color} position={position}>
      {option.label}
    </StatusTag>
  ) : null
}
